module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-28.f9ab8589.png";